"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateURLSearchParams = exports.CatalogBrowserHeaderInternal = exports.CatalogBrowserHeader = exports.CatalogBrowserSubplace = void 0;
const tslib_1 = require("tslib");
const catalog_core_1 = require("@tableau/catalog-core");
const catalog_messages_1 = require("@tableau/catalog-messages");
const data_catalog_shared_1 = require("@tableau/data-catalog-shared");
const shared_urls_1 = require("@tableau/shared-urls");
const vizportalclient_common_components_1 = require("@tableau/vizportalclient-common-components");
const widgets_1 = require("@tableau/widgets");
const react_1 = tslib_1.__importDefault(require("react"));
const react_router_1 = require("react-router");
const reselect_1 = require("reselect");
const CatalogBrowserSelectorItem_1 = require("./CatalogBrowserSelectorItem");
const Header = (0, vizportalclient_common_components_1.divWithStyle)('CatalogBrowserHeader', [
    data_catalog_shared_1.flexRowStyle,
    data_catalog_shared_1.headerPaddingStyle,
    data_catalog_shared_1.spaceHeaderContentStyle,
]);
const Title = (0, vizportalclient_common_components_1.divWithStyle)('CatalogBrowserTitle', data_catalog_shared_1.nonPlaceTitleStyle);
const Selector = (0, vizportalclient_common_components_1.divWithStyle)('CatalogBrowserSelector', {
    paddingLeft: widgets_1.TabStyles.Spacing.ExtraLargeSpace,
});
const GraphiQLLink = (0, vizportalclient_common_components_1.divWithStyle)('CatalogBrowserGraphiQLLink', {
    flex: 1,
    textAlign: 'right',
});
var CatalogBrowserSubplace;
(function (CatalogBrowserSubplace) {
    CatalogBrowserSubplace["Databases"] = "Databases";
    CatalogBrowserSubplace["Tables"] = "Tables";
})(CatalogBrowserSubplace = exports.CatalogBrowserSubplace || (exports.CatalogBrowserSubplace = {}));
function CatalogBrowserHeader(props) {
    const featureFlags = (0, catalog_core_1.useFeatureFlags)();
    const siteUrls = (0, catalog_core_1.useSiteUrls)();
    return (react_1.default.createElement(react_router_1.Route, null, ({ history }) => (react_1.default.createElement(data_catalog_shared_1.UrlSearchProvider, null, (urlSearch) => {
        var _a;
        return (react_1.default.createElement(CatalogBrowserHeaderInternal, { filesCount: (_a = props.filesCount) !== null && _a !== void 0 ? _a : 0, databasesCount: props.databasesCount, tablesCount: props.tablesCount, selectedSubplace: props.selectedSubplace, history: history, urls: siteUrls, urlSearch: urlSearch, featureFlags: featureFlags }));
    }))));
}
exports.CatalogBrowserHeader = CatalogBrowserHeader;
class CatalogBrowserHeaderInternal extends react_1.default.Component {
    constructor() {
        super(...arguments);
        this.memoizedCreateSubplaceList = (0, reselect_1.defaultMemoize)(createSubplaceList);
        this.renderDropdown = () => {
            const items = this.memoizedCreateSubplaceList(this.props.featureFlags.dataCloudInCatalogMVPEnabled, this.props.databasesCount, this.props.tablesCount);
            return (react_1.default.createElement(Selector, null,
                react_1.default.createElement(widgets_1.SingleSelectDropdown, { type: widgets_1.DropdownButtonType.Line, label: '', list: react_1.default.createElement(widgets_1.List, { items: items, selectedValue: this.props.selectedSubplace }), value: this.props.selectedSubplace, onChange: this.onChangeSubspace, style: { fontSize: 14 } }, this.selectedLabel(this.props.selectedSubplace, this.props.featureFlags.dataCloudInCatalogMVPEnabled))));
        };
        this.onChangeSubspace = (value) => {
            if (this.props.selectedSubplace !== value) {
                switch (value) {
                    case CatalogBrowserSubplace.Databases: {
                        const newParamsForDatabases = updateURLSearchParams(this.props.urlSearch.value);
                        this.props.history.push(this.props.urls.catalogDatabasesPath() + newParamsForDatabases);
                        break;
                    }
                    case CatalogBrowserSubplace.Tables: {
                        const newParamsForTables = updateURLSearchParams(this.props.urlSearch.value);
                        this.props.history.push(this.props.urls.catalogTablesPath() + newParamsForTables);
                        break;
                    }
                    default:
                        break;
                }
            }
        };
    }
    selectedLabel(subplace, dataCloudInCatalogMVPEnabled) {
        switch (subplace) {
            case CatalogBrowserSubplace.Databases:
                return catalog_messages_1.Messages.DatabasesAndFiles();
            case CatalogBrowserSubplace.Tables:
                return dataCloudInCatalogMVPEnabled ? catalog_messages_1.Messages.TablesAndObjects() : catalog_messages_1.Messages.Tables();
            default:
                return catalog_messages_1.Messages.DatabasesAndFiles();
        }
    }
    render() {
        return (react_1.default.createElement(Header, { "data-tb-test-id": 'catalog-browser-header' },
            react_1.default.createElement(Title, null, catalog_messages_1.Messages.ExternalAssets()),
            this.renderDropdown(),
            react_1.default.createElement(GraphiQLLink, null,
                react_1.default.createElement("a", { href: '/metadata/graphiql/' }, catalog_messages_1.Messages.QueryMetadataGraphiQL()))));
    }
}
exports.CatalogBrowserHeaderInternal = CatalogBrowserHeaderInternal;
// exported for testing purpose
function updateURLSearchParams(urlParams) {
    const paramValuesMap = (0, data_catalog_shared_1.searchToParamValuesMap)(urlParams);
    // reset order params to default
    (0, data_catalog_shared_1.setParamValues)(paramValuesMap, shared_urls_1.CatalogUrlParamKeys.order, []);
    return (0, data_catalog_shared_1.paramValuesMapToSearch)(paramValuesMap);
}
exports.updateURLSearchParams = updateURLSearchParams;
function createSubplaceList(dataCloudInCatalogMVPEnabled, databasesCount, tablesCount) {
    return [
        {
            value: CatalogBrowserSubplace.Databases,
            content: (react_1.default.createElement(CatalogBrowserSelectorItem_1.CatalogBrowserSelectorItem, { subplaceName: catalog_messages_1.Messages.DatabasesAndFiles(), count: databasesCount })),
        },
        {
            value: CatalogBrowserSubplace.Tables,
            content: (react_1.default.createElement(CatalogBrowserSelectorItem_1.CatalogBrowserSelectorItem, { subplaceName: dataCloudInCatalogMVPEnabled ? catalog_messages_1.Messages.TablesAndObjects() : catalog_messages_1.Messages.Tables(), count: tablesCount })),
        },
    ];
}
//# sourceMappingURL=CatalogBrowserHeader.js.map